import React, { useEffect, useState } from 'react'
import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import ExternalLink from 'core/components/ExternalLink'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Text from 'core/elements/Text'
import { routeManager } from 'core/utils/routes'
import { IHealthServiceDetailsPageTabs } from '../networks/model'
import { deleteImage, getHostGlanceEndpoint, testHostGlance } from './actions'

export default function DeleteImage(props) {
  const [showWarning, setShowWarning] = useState(false)
  const [glanceHostNotReachable, setGlanceHostNotReachable] = useState(false)

  useEffect(() => {
    const asyncCall = async () => {
      try {
        const endpoint = await getHostGlanceEndpoint()
        if (!endpoint) {
          setShowWarning(true)
        }
        await testHostGlance(endpoint)
      } catch (err) {
        if (err?.err?.code === 'ECONNABORTED') {
          setGlanceHostNotReachable(true)
        }
      }
    }
    asyncCall()
  }, [])

  // error/info message handling
  let infoMessage: React.ReactNode | undefined
  if (glanceHostNotReachable) {
    infoMessage = (
      <ErrorMessage>
        <Text variant="body2">
          Image library host not reachable. Please check the image service health{' '}
          <ExternalLink
            url={routeManager.routes.openstack.health.details.path({
              tab: IHealthServiceDetailsPageTabs.ServiceHealth,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </ExternalLink>
          .
        </Text>
      </ErrorMessage>
    )
  }

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteImage}
      title="Delete Image(s)"
      resourceLabel="image(s)"
      showInfo={!!infoMessage}
      infoMessage={infoMessage}
      disableSubmit={glanceHostNotReachable}
      subTitle={
        showWarning
          ? 'You are about to delete image(s) that belong to a host without an Image Library role. This action cannot be undone.'
          : 'This will permanently delete the following image(s):'
      }
    />
  )
}
